import { ca } from '@cian/analytics';

interface ITrackGoToReviewsPageArgs {
  objectId: number;
  rating: number;
  reviewsCount: number;
}

export const trackGoToNewReview = ({ objectId, rating, reviewsCount }: ITrackGoToReviewsPageArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentReviews',
    action: 'click',
    label: 'Write_Review',
    page: { pageType: 'Card', siteType: 'desktop' },
    products: [{ id: objectId, offerType: 'offer' }],
    extra: { rating, reviewsCount },
  });
};
